import { render, staticRenderFns } from "./htmlTemplate5.vue?vue&type=template&id=50dcdf24&scoped=true"
import script from "./htmlTemplate5.vue?vue&type=script&lang=js"
export * from "./htmlTemplate5.vue?vue&type=script&lang=js"
import style0 from "./htmlTemplate5.vue?vue&type=style&index=0&id=50dcdf24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dcdf24",
  null
  
)

export default component.exports